<template>
  <div class="box">
    <div class="birthdayDetail px-2" v-loading="birthdayLoading">
      <el-input
        class="input-search"
        placeholder="请输入姓名/部门"
        clearable
        prefix-icon="el-icon-search"
        v-model="searchValue"
        @change="searchChange"
      >
      </el-input>
      <div class="total-people">共：{{ EmployeeTotal }}人</div>
      <div class="detail-list">
        <div class="detail-item" v-for="list in BirthArray" :key="list.empno">
          <div class="item-icon">
            <img v-if="list.imageurl" :src="list.imageurl" alt="" />
          </div>
          <div class="item-info">
            <div class="item-info-top">
              <span class="left">{{ list.name }}</span>
              <span class="right"> {{ list.emprank1 }}</span>
            </div>
            <div class="item-info-bottom">
              <span
                class="text"
                v-for="item in list.orgpath.split('>')"
                :key="item"
                >{{ item }}</span
              >
            </div>
          </div>
          <div class="item-marks">
            <div class="item-marks-top">{{ list.type }}</div>
            <div class="item-marks-bottom">{{ list.time }}</div>
          </div>
        </div>
        <div
          class="detail-item"
          v-for="(list, index) in AnniversaryArray"
          :key="index"
        >
          <div class="item-icon">
            <img v-if="list.imageurl" :src="list.imageurl" alt="" />
          </div>
          <div class="item-info">
            <div class="item-info-top">
              <span class="left">{{ list.name }}</span>
              <span class="right"> {{ list.emprank1 }}</span>
            </div>
            <div class="item-info-bottom">
              <span
                class="text"
                v-for="(item, i) in list.orgpath.split('>')"
                :key="i"
                >{{ item }}</span
              >
            </div>
          </div>
          <div class="item-marks">
            <div class="item-marks-top">{{ list.type }}</div>
            <div class="item-marks-bottom">{{ list.time }}</div>
          </div>
        </div>
      </div>
      <div class="btn">
        <!-- <el-button @click="sendHolidayMsg">再次推送</el-button> -->
      </div>
    </div>
  </div>
</template>

<script>
import api from "@/apis";
import { getToken } from "@/utils/cookie";
export default {
  data() {
    return {
      birthdayLoading: false,
      searchValue: "",
      EmployeeTotal: 0,
      BirthArray: [],
      AnniversaryArray: [],
    };
  },
  mounted() {
    this.getDataList();
  },
  methods: {
    // 获取数据列表
    getDataList() {
      this.birthdayLoading = true;
      api
        .anniversaryReminder({
          empnoData: this.searchValue,
          empNo: getToken(),
        })
        .then((res) => {
          if (res.code == 200) {
            this.birthdayLoading = false;
            this.EmployeeTotal = res.data[0] && res.data[0].EmployeeTotal;
            this.BirthArray = res.data[0] && res.data[0].BirthArray;
            this.AnniversaryArray = res.data[0] && res.data[0].AnniversaryArray;
          }
        });
    },
    //搜索
    searchChange() {
      this.getDataList();
    },
    //再次推送
    sendHolidayMsg() {
      const empnoList = [];
      this.BirthArray.map((item) => {
        empnoList.push(item.empno);
      });
      this.AnniversaryArray.map((item) => {
        empnoList.push(item.empno);
      });

      api.sendBirthdayMsg(empnoList).then((res) => {
        if (res.code === 200) {
          this.$message({
            message: res.msg,
            type: "success",
          });
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
$zoom: 1020 / 375;
@media screen and (max-width: 600px) {
  .birthdayDetail {
    width: 100%;
  }
}
@media screen and (min-width: 600px) {
  .birthdayDetail {
    width: 276px * $zoom;
  }
}
.box {
  display: flex;
  justify-content: center;
}
.birthdayDetail {
  // @include container();
  min-height: 100vh;
  background: #fff;
  padding: 32px;
  .input-search {
    height: 60px;
    line-height: 60px;
    ::v-deep .el-input__inner {
      height: 60px;
      line-height: 60px;
      background: rgba(235, 237, 242, 0.6);
      border: none;
      font-size: 24px;
      font-family: PingFangSC-Regular, PingFang SC;
      border-radius: 4px;
    }
    ::v-deep .el-icon-search {
      font-size: 24px;
      line-height: 60px;
    }
  }
  .total-people {
    margin-top: 40px;
    margin-bottom: 20px;
    font-family: PingFang-SC-Heavy, PingFang-SC;
    font-size: 28px;
    color: #4ea27c;
  }
  .detail-list {
    overflow-y: auto;
    // height: calc(100vh - 450px);
    /* 隐藏滚动条 */
    scrollbar-width: none; /* firefox */
    -ms-overflow-style: none; /* IE 10+ */
    &::-webkit-scrollbar {
      display: none; /* Chrome Safari */
    }
    .detail-item {
      display: flex;
      justify-content: space-between;
      padding: 40px 0;
      border-bottom: 1px solid #f1f1f1;
      .item-icon {
        overflow: hidden;
        width: 60px;
        height: 60px;
        margin-top: 5px;
        background: #eee;
        border-radius: 50%;
        img {
          width: 100%;
          height: 100%;
        }
      }
      .item-info {
        width: 65%;
        margin-left: 32px;
        .item-info-top {
          font-family: PingFangSC-Medium, PingFang SC;
          line-height: 44px;
          .left {
            font-size: 32px;
            color: #282b32;
            font-weight: 500;
          }
          .right {
            font-size: 24px;
            color: #969b9e;
          }
        }
        .item-info-bottom {
          width: 90%;
          .text {
            font-size: 22px;
            font-family: PingFangSC-Regular, PingFang SC;
            color: #282b32;
            &::after {
              content: " | ";
            }
            &:last-child {
              &::after {
                content: " | ";
                display: none;
              }
            }
          }
        }
      }
      .item-marks {
        font-size: 24px;
        font-family: PingFangSC-Regular, PingFang SC;
        color: #969b9e;
        line-height: 34px;
        text-align: right;
        .item-marks-top,
        .item-marks-bottom {
          margin-top: 10px;
        }
      }
    }
  }
  .btn {
    margin-top: 100px;
    .el-button {
      width: 100%;
      height: 96px;
      background: #4ea27c;
      border: none;
      border-radius: 16px;
      font-size: 32px;
      font-family: PingFang-SC-Heavy, PingFang-SC;
      font-weight: 800;
      color: #ffffff;
    }
  }
}
</style>
